// @flow

import React, { Component } from 'react';
import logger from '../../helpers/logger';

// EmptyComponent should at least get error in it's props
type Props = {
  error?: string,
};

class EmptyComponent extends Component<Props> {
  static defaultProps = {
    error: '',
  };

  componentDidMount() {
    this.logError();
  }

  async logError() {
    const {
      error,
      ...rest
    } = this.props;
    console.warn('Ended up in EmptyComponent with props: ', rest);

    try {
      await logger({
        message: 'Ended up with an EmptyComponent',
        path: window.location.pathname,
        error,
        props: rest,
      });
    } catch (tryError) {
      console.error("coulnd't connect to graylog: ", tryError);
    }
  }

  render() {
    return <div className="empty-component" />;
  }
}

export default EmptyComponent;
